<!-- <div class="modal fade" id="childModal" tabindex="-1" aria-labelledby="childModalLabel" aria-hidden="true">
    <div class="modal-dialog">
      <div class="modal-content">
        <div class="modal-header">
          <h5 class="modal-title" id="childModalLabel">Child Modal</h5>
          <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
        </div>
        <div class="modal-body">
          This is the modal content inside the child component.
        </div>
      </div>
    </div>
</div> -->

<!--  -->
<div class="modal fade" id="childModal" tabindex="-1" data-bs-backdrop="static" aria-labelledby="childModalLabel" aria-hidden="true">
    <div class="modal-dialog modal-dialog-centered modal-lg">
      <div class="modal-content view-more-modal rounded-4">
  
        <!-- Close Button -->
        <button type="button" class="btn-close position-absolute top-0 end-0 m-3" (click)="closeButtonClicked()" data-bs-dismiss="modal" aria-label="Close"></button>
  
       

          <div class="addAnotherCharity">
              <div class="form-wrapper">
                <h3>Add New Charity</h3><br>
                <form [formGroup]="charityForm" (ngSubmit)="onSubmit()">
                  <label>
                    <div class="label-container">Charity Name<span class="required">*</span></div>
                    <div class="search-bar">
                      <input formControlName="charityName" [formControl]="searchControl" [(ngModel)]="searchText"
                        (input)="onSearchInput($event)" placeholder="Start typing to search or enter a new charity name" class="form-control" />
                        <ul class="dropdown-list" *ngIf="(favCharityNameList?.length || showNoResult || searching) && searchText" (scroll)="onDropdownScroll($event)">
                        <ng-container *ngIf="searching">
                          <li class="skeleton-item" *ngFor="let s of [1,2,3]"></li>
                        </ng-container>
                        <li *ngFor="let option of favCharityNameList" (click)="selectCharityOption($event, option);closeDropdown()">
                          {{ option.orgName }} <br>
                          <span style="font-size: 15px;">{{option?.orgCity}}, {{option?.orgState}} &nbsp; <ng-container *ngIf="option?.orgEinNumber"> EIN: {{option?.orgEinNumber}}</ng-container></span>
                        </li>
                        <li *ngIf="loading" class="loading-option">
                          Loading...
                        </li>
                  
                        <li *ngIf="showNoResult && !searching" class="no-result-option" (click)="closeDropdown()">
                          No matching charity found. Please enter the details manually to proceed.
                        </li>
                      </ul>
                      <!-- <span class="search-icon"><img class="lensImage" src="../../../../assets/images/lens-icon.svg"></span> -->
                    </div>
                  </label>
                  
            
                  <label>
                    <div class="label-container">Organization Type<span class="required">*</span></div>
                    <!-- <select formControlName="organizationType">
                      <option value="" disabled>Select</option>
                      <option *ngFor="let type of organizationTypes" [value]="type">{{ type }}</option>
                    </select> -->
                    <ng-select id="organizationType" (click)="closeDropdown()"
                    formControlName="organizationType" placeholder="Select">
                    <ng-option
                        *ngFor="let option of charityCategoryList" [value]="option._id">{{option.name}}</ng-option>
                  </ng-select>
                  </label>
                  
                  
                  
                  <!-- <label>
                    City<span class="required">*</span>
                    <select formControlName="city">
                      <option value="" disabled>Select</option>
                      <option *ngFor="let c of cities" [value]="c">{{ c }}</option>
                    </select>
                  </label> -->
                  <label>
                    <div class="label-container">City<span class="required">*</span></div>
                    <input id="city" (input)="preventSpaceInInput($event)" (click)="closeDropdown()"
                    formControlName="city" placeholder="City">
                  
                  </label>
            
                  <!-- <label>
                    State<span class="required">*</span>
                    <select formControlName="state">
                      <option value="" disabled>Select</option>
                      <option *ngFor="let s of states" [value]="s">{{ s }}</option>
                    </select>
                  </label> -->
                  <label>
                    <div class="label-container">State<span class="required">*</span></div>
                    <input id="state" (input)="preventSpaceInInput($event)" (click)="closeDropdown()"
                    formControlName="state" placeholder="State">
                  </label>

                  <br>
            
                  <button class="add-charity" [disabled]="!charityForm.valid" type="submit" data-bs-dismiss="modal" aria-label="Close">Add Charity</button>
                </form>
              </div>
          </div>
  
      </div>
    </div>
  </div>
